import {
  CLEAN_STATE,
  GET_RECORD_LIQUIDATION,
  GET_RECORD_LIQUIDATION_COIN,
  GET_RECORD_LIQUIDATION_PAYMENT_SITUATION,
  POST_RECORD_LIQUIDATION
} from '../types'

const initialState = {
  cbCoin: [],
  cbPaymentSituaction: [],
  liquidation: [],
  response: '',
  errors: [],
  loading: true
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_RECORD_LIQUIDATION:
      return {
        ...state,
        liquidation: action.payload,
        loading: false
      }
    case GET_RECORD_LIQUIDATION_COIN:
      return {
        ...state,
        cbCoin: action.payload,
        loading: false
      }
    case GET_RECORD_LIQUIDATION_PAYMENT_SITUATION:
      return {
        ...state,
        cbPaymentSituaction: action.payload,
        loading: false
      }
    case POST_RECORD_LIQUIDATION:
      return {
        ...state,
        response: action.payload,
        loading: false
      }
    case CLEAN_STATE:
      return {
        ...state,
        cbCoin: [],
        cbPaymentSituaction: [],
        liquidation: [],
        response: '',
        errors: [],
        loading: true
      }

    default:
      return state
  }
}
